import React from "react";

import {useInvestmentOfferTypes} from "../hooks/use_investment_offer_types";
import {InvestmentOfferTile} from "./InvestmentOfferTile";
import {InvestmentOfferTiles} from "./InvestmentOfferTiles";

export const InvestmentOfferTypesSection = () => {
    const investmentOfferTypes = useInvestmentOfferTypes();

    return (
        <InvestmentOfferTiles title="Zainwestuj w nieruchomości mieszkalne">
            {investmentOfferTypes.map((investmentOfferType) => {
                return <InvestmentOfferTile key={investmentOfferType.title} {...investmentOfferType} ratioVariant="verticalLong" />;
            })}
        </InvestmentOfferTiles>
    );
};
import React from "react";

import {useInvestmentOfferTypes} from "../hooks/use_investment_offer_types";
import {InvestmentOfferTile} from "./InvestmentOfferTile";
import {InvestmentOfferTiles} from "./InvestmentOfferTiles";

export const InvestmentOfferTypesSection = () => {
    const investmentOfferTypes = useInvestmentOfferTypes();

    return (
        <InvestmentOfferTiles title="Zainwestuj w nieruchomości mieszkalne">
            {investmentOfferTypes.map((investmentOfferType) => {
                return <InvestmentOfferTile key={investmentOfferType.title} {...investmentOfferType} ratioVariant="verticalLong" />;
            })}
        </InvestmentOfferTiles>
    );
};
